import React, { useState, useEffect } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddItemProperty = ({ show, onClose, onSuccess }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [propertyTypeOptions, setPropertyTypeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [propertyName, setPropertyName] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return; // optional: fetch only when modal shown
    fetch(`${baseURL}/propertytype/type/active`)
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.map((item) => ({
          value: item.sno,
          label: item.propertytype_name,
        }));
        setPropertyTypeOptions(options);
      })
      .catch((error) => {
        console.error('Error fetching property types:', error);
      });
  }, [show, baseURL]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const validationErrors = {};

    if (!propertyName.trim()) {
      validationErrors.propertyName = 'This field is required.';
    }

    if (!selectedOption) {
      validationErrors.selectedOption = 'This field is required.';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);

    const payload = {
      property_name: propertyName.trim(),
      propertytype: selectedOption.value,
      description: description.trim() || null,
    };

    try {
      const res = await axios.post(`${baseURL}/property`, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (res.status === 201) {
        setPropertyName('');
        setSelectedOption(null);
        setDescription('');
        onClose();
        if (onSuccess) onSuccess();
        toast.success("Property Created successfully!");
      } else {
        setErrors({ general: 'Failed to create property.' });
        toast.error("Failed to create property.");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.errors) {
        const apiErrors = err.response.data.errors;
        const apiValidationErrors = {};

        if (apiErrors.property_name) {
          apiValidationErrors.propertyName = apiErrors.property_name[0];
        }
        if (apiErrors.propertytype) {
          apiValidationErrors.selectedOption = apiErrors.propertytype[0];
        }
        setErrors(apiValidationErrors);
      } else if (err.response && err.response.data && err.response.data.error) {
        setErrors({ general: err.response.data.error });
      } else {
        setErrors({ general: 'Failed to create property.' });
      }
      console.error('API error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose} centered>
      <form onSubmit={handleSubmit} className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Property</h3>
          <Button
            variant=""
            type="button"
            className="close px-6 py-2"
            onClick={onClose}
          >
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
       
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Property Type <span className="required">*</span>
              </label>
              <Select
                placeholder="Select Property Type"
                value={selectedOption}
                onChange={setSelectedOption}
                options={propertyTypeOptions}
                isDisabled={loading}
              />
              {errors.selectedOption && (
                <small className="text-danger">{errors.selectedOption}</small>
              )}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Property <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Property"
                value={propertyName}
                onChange={(e) => setPropertyName(e.target.value)}
                disabled={loading}
              />
              {errors.propertyName && (
                <small className="text-danger">{errors.propertyName}</small>
              )}
            </div>

            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">Description</label>
              <textarea
                rows={3}
                className="form-control h-auto"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                disabled={loading}
              />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
            <Button
              type="submit"
              className="btn btn-sm btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Creating...
                </>
              ) : (
                <>
                  Create Property <i className="fas fa-angle-double-right ms-2"></i>
                </>
              )}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddItemProperty;
